<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn to="/ticket/calender" icon v-bind="attrs" v-on="on">
                <v-badge v-if="count" color="primary" :content="count">
                    <v-icon>mdi-earth</v-icon>
                </v-badge>
                <v-icon v-else>mdi-earth</v-icon>
            </v-btn>
        </template>
        <span>IATA print kalender</span>
    </v-tooltip>
</template>

<script>
import moment from "moment/moment";
import User from "@/models/User/User.js";
import UserGroup from "@/models/User/UserGroup/UserGroup.js";
import Dataset from "@/models/Dataset/Dataset.js";

export default {
    data() {
        return {
            count: 0,
        }
    },
    computed: {
        user() {
            return User.loggedInUser();
        },
    },
    methods: {
        async fetchTicketPrintCount() {
            let filters = {
                user_id: this.user.id,
            };
            if (this.user.user_group_id === UserGroup.CFS || this.user.user_group_id === UserGroup.IATA || this.user.user_group_id === UserGroup.DIRECTION) {
                filters.user_id = null; // CFS, IATA, and DIRECTION users see all tickets
            }

            const ticketToPrintPerDay = await Dataset.call('dossier/ticket/tickets-to-print-per-print-date', filters);
            const ticketToPrintToday = ticketToPrintPerDay.find(item => moment(item.print_at).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD'));

            this.count = ticketToPrintToday ? ticketToPrintToday.total : 0;
        },
        isToday(date) {
            return moment(date).isSame(moment(), 'day');
        },
        addedToList(isPrinted) {
            if (isPrinted) {
                return;
            }

            this.count++;
        },
        removedFromList(wasPrinted) {
            if (wasPrinted) {
                return;
            }

            this.count--;
        },
        stayedOnList(isPrinted) {
            if (isPrinted) {
                this.count--;
                return;
            }

            this.count++;
        },
        updatePrintCount(printAt, printedAt, originalPrintAt, originalPrintedAt) {
            const isPrintAtChanged = printAt !== originalPrintAt;
            const isPrintedAtChanged = printedAt !== originalPrintedAt;
            const isTodayPrintAt = this.isToday(printAt);
            const isPrinted = printedAt !== null;
            const wasPrinted = originalPrintedAt !== null;

            if (isPrintAtChanged && isTodayPrintAt) {
                return this.addedToList(isPrinted);
            }

            if (isPrintAtChanged && !isTodayPrintAt) {
                return this.removedFromList(wasPrinted);
            }

            if (!isPrintAtChanged && isTodayPrintAt && isPrintedAtChanged) {
                this.stayedOnList(isPrinted);
            }
        }
    },
    sockets: {
        'dossier-ticket:updated'(socketData) {
            const { print_at, printed_at } = socketData.data;
            const originalPrintAt = socketData.meta.original.print_at;
            const originalPrintedAt = socketData.meta.original.printed_at;
            const shouldFilterByUser = ![UserGroup.CFS, UserGroup.IATA, UserGroup.DIRECTION].includes(this.user.user_group_id);

            if (shouldFilterByUser && socketData.meta.related.dossier.user_id !== this.user.id) {
                return;
            }

            this.updatePrintCount(print_at, printed_at, originalPrintAt, originalPrintedAt);
        }
    },
    created() {
        this.$socket.emit('room:join', 'dossier-tickets');
        this.fetchTicketPrintCount();
    },
    beforeDestroy() {
        this.$socket.emit('room:leave', 'dossier-tickets');
    }
}
</script>
